"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./SearchSelect.css");
var Icon_1 = require("../icon/Icon");
var Search_1 = require("../input/search/Search");
var Dropdown_1 = require("../dropdown/Dropdown");
var react_1 = require("react");
function SearchSelect(props) {
    var htmlProps = (function (_a) {
        var 
        //dropdown props
        defaultLabel = _a.defaultLabel, disabled = _a.disabled, onOpen = _a.onOpen, onClose = _a.onClose, onChange = _a.onChange, 
        //search props
        value = _a.value, onInputClick = _a.onInputClick, onInputSubmit = _a.onInputSubmit, onInputChange = _a.onInputChange, onInputReturn = _a.onInputReturn, rest = __rest(_a, ["defaultLabel", "disabled", "onOpen", "onClose", "onChange", "value", "onInputClick", "onInputSubmit", "onInputChange", "onInputReturn"]);
        return rest;
    })(props);
    var _a = __read(react_1.useState(false), 2), expanded = _a[0], setExpanded = _a[1];
    return (React.createElement(Dropdown_1.Dropdown, __assign({ role: 'search' }, htmlProps, { className: classnames_1.default('SearchSelect', props.className, 'blob'), theme: Dropdown_1.DropdownTheme.box, expanded: expanded, disabled: props.disabled, label: React.createElement(React.Fragment, null,
            React.createElement(Icon_1.Icon, { className: 'SearchSelect_toggleIcon', type: Icon_1.IconType.search }),
            React.createElement("span", { className: 'd-none d-md-inline' }, props.defaultLabel || 'Search')), onOpen: function (dropdown, e) {
            setExpanded(true);
            // const searchInput = dropdown ? dropdown.querySelector('.Search_input') as HTMLElement : null
            // if (searchInput) {
            //   setTimeout(() => searchInput.focus())
            // }
            if (props.onOpen)
                props.onOpen(dropdown, e);
        }, onClose: function (e) {
            setExpanded(false);
            if (props.onClose)
                props.onClose(e);
        } }),
        React.createElement(Search_1.Search, { role: undefined, value: props.value, disabled: props.disabled, onInputClick: function (e) {
                if (props.onInputClick)
                    props.onInputClick(e);
            }, onSubmit: function (value, e) {
                e.preventDefault();
                setExpanded(false);
                if (props.onInputSubmit)
                    props.onInputSubmit(value, e);
                if (props.onChange)
                    props.onChange(e);
            }, onChange: function (value, e) {
                if (props.onInputChange)
                    props.onInputChange(value, e);
            }, onReturn: function (value, e) {
                if (props.onInputReturn)
                    props.onInputReturn(value, e);
            } })));
}
exports.SearchSelect = SearchSelect;
